import React from 'react';

export const DefaultLayout = React.lazy(() => import('../containers/DefaultLayout'));

export const SignIn = React.lazy(() => import('../screens/public/SignIn'));

const Quotations = React.lazy(() => import('../screens/secure/Quotation'));
const QuotationApprove = React.lazy(() => import('../screens/secure/Quotation/Approve'));
const QuotationReject = React.lazy(() => import('../screens/secure/Quotation/Reject'));
const AddQuotation = React.lazy(() => import('../screens/secure/Quotation/Add'));
const QuotationView = React.lazy(() => import('../screens/secure/Quotation/View'));
const EditQuotation = React.lazy(() => import('../screens/secure/Quotation/Edit'));

const Clients = React.lazy(() => import('../screens/secure/Client'));
const AddClient = React.lazy(() => import('../screens/secure/Client/Add'));
const EditClient = React.lazy(() => import('../screens/secure/Client/Edit'));
const ClientView = React.lazy(() => import('../screens/secure/Client/View'));

const Departments = React.lazy(() => import('../screens/secure/Department'));
const AddDepartment = React.lazy(() => import('../screens/secure/Department/Add/Department'));
const EditDepartment = React.lazy(() => import('../screens/secure/Department/Edit/Department'));
const DepartmentView = React.lazy(() => import('../screens/secure/Department/View'));
const SubDepartments = React.lazy(() => import('../screens/secure/Department/SubDepartment'));

const Tests = React.lazy(() => import('../screens/secure/Test'));
const AddTest = React.lazy(() => import('../screens/secure/Test/Add'));
const TestView = React.lazy(() => import('../screens/secure/Test/View'));
const EditTest = React.lazy(() => import('../screens/secure/Test/Edit'));

const routes = [
  {
    exact: true,
    name: 'Home',
    path: '/',
  },
  {
    component: Quotations,
    exact: true,
    name: 'Quotations',
    path: '/quotations',
  },
  {
    component: QuotationApprove,
    exact: true,
    name: 'Approve',
    path: '/quotations/:id/approve/:name',
  },
  {
    component: QuotationReject,
    exact: true,
    name: 'Reject',
    path: '/quotations/:id/reject/:name',
  },
  {
    component: AddQuotation,
    exact: true,
    name: 'Add',
    path: '/quotations/add',
  },
  {
    component: QuotationView,
    exact: true,
    name: 'Detail',
    path: '/quotations/:id/detail',
  },
  {
    component: EditQuotation,
    exact: true,
    name: 'Edit',
    path: '/quotations/:id/edit',
  },
  {
    component: Clients,
    exact: true,
    name: 'Clients',
    path: '/clients',
  },
  {
    component: AddClient,
    exact: true,
    name: 'Add',
    path: '/clients/add',
  },
  {
    component: EditClient,
    exact: true,
    name: 'Edit',
    path: '/clients/:id/edit',
  },
  {
    component: ClientView,
    exact: true,
    name: 'Detail',
    path: '/clients/:id/detail',
  },
  {
    component: Departments,
    exact: true,
    name: 'Departments',
    path: '/departments',
  },
  {
    component: AddDepartment,
    exact: true,
    name: 'Add',
    path: '/departments/add',
  },
  {
    component: EditDepartment,
    exact: true,
    name: 'Add',
    path: '/departments/:id/edit',
  },
  {
    component: DepartmentView,
    exact: true,
    name: 'Detail',
    path: '/departments/:id/detail',
  },
  {
    component: SubDepartments,
    exact: true,
    name: 'SubDepartments',
    path: '/departments/:id/sub_departments',
  },

  {
    component: Tests,
    exact: true,
    name: 'Tests',
    path: '/tests',
  },
  {
    component: AddTest,
    exact: true,
    name: 'Add',
    path: '/tests/add',
  },
  {
    component: TestView,
    exact: true,
    name: 'Detail',
    path: '/tests/:id/detail',
  },
  {
    component: EditTest,
    exact: true,
    name: 'Edit',
    path: '/tests/:id/edit',
  },
];

export default routes;
